export default {
  companyName: '',
  alias: '',
  addressLine1: '',
  addressLine2: '',
  town: '',
  county: '',
  postCode: '',
  country: '',
  taxi: false,
  chauffer: false,
  rideHail: false,
  coach: false,
  carRental: false,
  microMobility: false,
  termsAndConditions: '',
}
